import { useEffect, useState } from 'react';
import { ClickAppIcon, PaymeIcon } from 'icons';
import { useTranslations } from 'next-intl';
import { PatternFormat } from 'react-number-format';

import { useAppSelector } from 'store';

import { getPlatform } from 'modules/global';
import { useBuyPremium, usePlanPrice } from 'modules/pro';

import { Merchant } from './merchants';
import { PlanOption } from './plan-option';

const paymentMethods = [
  { id: 'payme', logo: <PaymeIcon /> },
  { id: 'click', logo: <ClickAppIcon /> }
];

export const PaymentPlanSelector = () => {
  const t = useTranslations();
  const { plans } = usePlanPrice();
  const { mutate } = useBuyPremium();
  const userPhone = useAppSelector(({ user }) => user.phone);
  const [phone, setPhone] = useState(userPhone || '');
  const [error, setError] = useState('');
  const [selectedPlan, setSelectedPlan] = useState(plans?.[2]);
  const [selectedMethod, setSelectedMethod] = useState(paymentMethods[0]);

  const onBuyPremium = () => {
    const replacedPhone = phone.replace(/\s|-/g, '').replace(/^\+998/, '');

    if (!replacedPhone) {
      setError(t('auth.phone_validation_message'));
      return;
    }

    if (replacedPhone.length !== 9) {
      setError(t('auth.telefon_raqam_xato'));
      return;
    }

    setError('');
    mutate({
      type: selectedMethod.id,
      month_count: selectedPlan?.month_count,
      platform: getPlatform(),
      phone: replacedPhone
    });
  };

  useEffect(() => {
    if (userPhone) {
      setPhone(userPhone.replace(/^\+998/, ''));
    }
  }, [userPhone]);

  return (
    <div className="space-y-4.5 flex flex-col justify-between rounded-2xl bg-white px-2 py-4 sm:p-5 order-1 lg:order-2">
      <div className="space-y-4.5">
        <div>
          <PatternFormat
            format="+998 ## ### ## ##"
            mask=" "
            value={phone}
            onChange={e => setPhone(e.target.value)}
            allowEmptyFormatting
            className="!mb-0 !h-11 w-full !rounded-xl !border !border-transparent !bg-gray-100 !px-3 hover:!border-green-500 hover:!outline-green-500 focus:!outline-green-500"
          />
          {error && <p className="text-xs text-red-500">{error}</p>}
        </div>

        <div className="space-y-4">
          {plans?.map(plan => (
            <PlanOption
              key={plan.id}
              plan={plan}
              selected={selectedPlan?.id === plan.id}
              onSelect={() => setSelectedPlan(plan)}
            />
          ))}
        </div>
        <div>
          <p className="mb-2 font-medium text-gray-500">{t('tolov_turi')}</p>
          <div className="grid grid-cols-3 gap-3">
            {paymentMethods.map(method => (
              <Merchant
                key={method.id}
                logo={method.logo}
                selected={selectedMethod.id === method.id}
                onSelect={() => setSelectedMethod(method)}
              />
            ))}
          </div>
        </div>
      </div>
      <div className="mt-4.5">
        <div
          onClick={onBuyPremium}
          className="from-green-450 shadow-green-md to-blue-450 z-0 mt-4 flex cursor-pointer items-center justify-center rounded-xl bg-gradient-to-tl p-0.5 transition-all duration-300 active:shadow-none ease-in-out active:translate-y-1"
        >
          <div className="shine-button from-green-450 to-blue-450 relative z-10 w-full rounded-[0.625rem] bg-gradient-to-br py-3 pl-2 pr-3 text-center font-medium text-white">
            {t('tolov_qilish')}
            {selectedPlan ? `: ${selectedPlan?.price?.toLocaleString('ru')} ${t('sum')}` : null}
          </div>
        </div>
      </div>
    </div>
  );
};
